(
    function (window, document, $, undefined) {
        function showHint(e) {
            e.preventDefault();

            const cta = $('#hint-cta'),
                copy = $('#hint-copy');

            if (cta.length === 1 && copy.length === 1) {
                cta.toggleClass('d-none');
                copy.toggleClass('d-none')
            }
        }

        $(document).ready(
            function () {
                const cbc = $('.chat-bubble-container'),
                    cta = $('#hint-cta .cta a');

                if (cbc.length === 1) {
                    cbc.addClass('expand');
                }

                if (cta.length === 1) {
                    cta.on('click', showHint);
                }
            }
        );
    }
)(window, document, window.jQuery);